export const getRentalPeriodLabel = (rateLabel) => {
  const label = String(rateLabel || "7+ Days Rate").trim();

  const minimumDays = label.match(/(\d+)\s*\+\s*days?/i);
  if (minimumDays) {
    return `${minimumDays[1]}+ days rental`;
  }

  const dayRange = label.match(/(\d+)\s*[-–]\s*(\d+)\s*days?/i);
  if (dayRange) {
    return `${dayRange[1]}–${dayRange[2]} day rental`;
  }

  const exactDays = label.match(/(\d+)\s*days?/i);
  if (exactDays) {
    return `${exactDays[1]}-day rental`;
  }

  if (/daily/i.test(label)) {
    return "Daily rental";
  }

  const cleanedLabel = label.replace(/\s*rate\s*$/i, "").trim();
  return cleanedLabel || "Rental rate";
};

export const getVehicleRateSummary = (rateLabel, kilometreOption) =>
  `${getRentalPeriodLabel(rateLabel)} · ${kilometreOption}`;
